import axios from "axios";
export default axios.create({
  // baseURL: "http://localhost:5000/",
  // baseURL: "http://192.168.0.15:4000/",
  baseURL: "https://api.mphedlab.in/",
});
